var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{attrs:{"width":"100%","height":_vm.$vuetify.breakpoint.smAndUp ? '238' : 'auto',"src":_vm.$vuetify.breakpoint.smAndUp
        ? _vm.data.path_desktop
        : _vm.data.path_mobile
        ? _vm.data.path_mobile
        : _vm.data.path_desktop,"cover":"","alt":_vm.data.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }